import checkboxIcon from '../../icons/checkbox-icon';
import { initReleaseUI } from '../../releases';

let _visibleReleases; 
let _updateSearch;


export const updateReleaseData = (releases, masterplan) => {
       
    let visibleReleases = masterplan.findReleases();
    let container = $('#release-types .property-types__options');

    if(container && _visibleReleases == null)
    {
 
        const selectedReleases = _getSelectedReleasesArray();
        const releasesList = _getAvailableReleases(releases, visibleReleases);
        const filterList = _filterList(releasesList, selectedReleases);  
        const areAllSelected = _areAllSelected(filterList); 
        const markUp = _getReleaseFilterMarkup(filterList);
 
        container.append(markUp);
        checkboxIcon();
        initReleaseCheckBox(_updateSearch);
        setTitle(filterList, areAllSelected); 

        initReleaseUI();

        _visibleReleases = visibleReleases;
    }
}


export default (updateSearch) => {   
        _updateSearch = updateSearch;
}

const initReleaseCheckBox = (updateSearch) => {


    //listen for the Select All check box
    let allCb = document.querySelector('.releases-search__filter-checkbox_all');
    let cbInputs = Array.from(document.querySelectorAll('.releases-search__filter-checkbox'));
    //console.log(allCb, cbInputs);
    
    const setAll = (value) => {       
        cbInputs.forEach((i) => {
            //set all checkbox value without update
            updateSearch({ [i.name]: i.value }, value ? 'APPEND' : 'REMOVE');
        });
    };
  

    cbInputs.forEach((input) => {
        input.addEventListener('change', () => {

            cbInputs.forEach((cb) => {
                //on change set all non-selected checkbox values - to prevent the ui and js data getting out of sync
                if(cb.value != input.value)  {
                    updateSearch({ [cb.name]: cb.value }, cb.checked ? 'APPEND' : 'REMOVE'); 
                }
            });

            //set the clicked checkbox and force search refresh
            updateSearch({ [input.name]: input.value }, input.checked ? 'APPEND' : 'REMOVE', input);
        });
    });


        
    if(allCb) {
        allCb.addEventListener('change', (i) => {     

            setAll(false);
            //force search update with current values 
            updateSearch(null,null, i.currentTarget);
       }); 
    } 

    //set init defaults
    cbInputs.forEach((i) => { 
            updateSearch({ [i.name]: i.value }, i.checked ? 'APPEND' : 'REMOVE');
    });

    // trigger renew filter
    updateSearch(null,null, ".releases-search__filter-checkbox");
}; 


//private helpers -------------------------


const _getReleaseFilterMarkup = (releasesList) => {
    
    let areAllSelected = _areAllSelected(releasesList);
    let selectedCount = _selectedCount(releasesList);

    const markup = `<label class="form__control-group form__control-group--property-type form__control-group--checkbox">
        <input class="form__control-group releases-search__filter-checkbox_all" type="checkbox" name="Releases" id="all" value="All" ${areAllSelected || selectedCount === 0 ? 'checked' : ''} />
        <CheckboxIcon></CheckboxIcon>
        Show All 
    </label>             
    ${releasesList.map(r => `<label class="form__control-group form__control-group--releases form__control-group--checkbox">
        <input class="form__control-group releases-search__filter-checkbox" name="Releases" id="${r.Value}" value="${r.Value}" type="checkbox" ${r.IsChecked ? 'checked' : ''} />
            <CheckboxIcon></CheckboxIcon>
            <label for="${r.Title}">${r.Title}</label>
        </label>`).join('')}

    <label class="property-types__toggle-close" for="releases-types__toggle-input">Close</label>`;
                  
    return markup;
}

//use only releases the business want to show
const _getAvailableReleases = (rawReleases, visibleReleases) => {
    let releasesList = [];
    for(let r of rawReleases)
    {
        if(_isVisibleRelease(visibleReleases, r)){
            releasesList.push(r);
        }
    }

    return releasesList;
}


const _isVisibleRelease = (visibleReleases, release) => {
    if(visibleReleases && release)
    {
        for (let r of visibleReleases)
        {
            if(r.name == release.LotExclusivity) return true;
        }
    }
    return false;
}

//this is (sort of) a duplicate of updateLabelText in releases.js 
const setTitle = (releasesList, areAllSelected) => {
    
    let selectedCount = _selectedCount(releasesList);

    let cbTitle = "";
    if (areAllSelected || selectedCount == 0)
    {
        cbTitle = "Show All";
    }
    else if (selectedCount > 1)
    {
        cbTitle = selectedCount + " options selected";
    }
    else if (selectedCount == 1)
    {
        let singleTitle = releasesList.filter(v => v.IsChecked)[0].Title;
        cbTitle = singleTitle;
    }

    $("#release-types-title").text(cbTitle);
}

const _filterList = (releasesList, selectedReleases) => {
    var noDuplicates = _removeDuplicates(releasesList, "ExtraSearch"); 
    var filterList = [];

    for(let r of noDuplicates)
    {
        if(r.ExtraSearch == "") continue; 
        
        let value = r.ReleaseDataName; //r.ExtraSearch.toLowerCase().replace(" ","");

        let isChecked = selectedReleases ? selectedReleases.indexOf(value) > -1 : false;


        let o = { Title : r.ExtraSearch, Value : value , IsChecked : isChecked  };

        filterList.push(o);
    }

    return filterList;
}

const _removeDuplicates = (myArr, prop) => {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}


const _areAllSelected = (checkedItems) => {
    //find out if all the IsChecked properties are set to true; ie: are all checkboxes selected?
    if(checkedItems) {
        return checkedItems.every(v => v === true);
    }

    return false;
}

const _checkedItems = (releasesList) => {
    return releasesList.map(r => r.IsChecked);
}

const  _selectedCount = (releasesList) => _checkedItems(releasesList).filter(v => v).length;


//get selected from query string, passed through from C# 
const _getSelectedReleasesArray = () => {
    let releaseTypesEle = document.querySelector('#release-types');
    let selectedReleases = "";

    if(releaseTypesEle)
    {
        let str = releaseTypesEle.getAttribute("data-selected-releases");

        if(str){
            selectedReleases = str.split("|");
        }
    }
     
    return selectedReleases;
}